import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthService } from "api/auth.service";
import { styleHelpers } from "helpers/styleHelpers";

import { ReactComponent as ICON_PROFILE } from "assets/images/menu/icon_profile.svg";
import { toast } from "react-toastify";

export default function EditProfileMenu() {
  const location = useLocation();
  const navigation = useNavigate();

  const handleLogout = async () => {
    toast.info("Am inceput procesul de delogare...");
    await AuthService.logout()
      .then(() => {
        toast.success("Gata! Ai fost delogat cu succes.");
      })
      .catch(() => {
        toast.warn(
          "A aparut o eroare la comunicarea cu serverul, insa te-am delogat cu succes!",
        );
      })
      .finally(() => {
        navigation("/");
        localStorage.clear();
      });
  };

  return (
    <div className="header-edit-profile">
      <div className="header-edit-profile-icon-container">
        <ICON_PROFILE />
      </div>

      <div className="header-edit-profile-content">
        <div
          onClick={() => navigation("/contul-meu")}
          className={`${styleHelpers.getEPDivClass(location, "/contul-meu")}`}
        >
          <p>Detalii cont</p>
        </div>
        {/*<div*/}
        {/*  onClick={() => navigation("/recomandari")}*/}
        {/*  className={`${styleHelpers.getEPDivClass(location, "/recomandari")}`}*/}
        {/*>*/}
        {/*  <p>Recomandari</p>*/}
        {/*</div>*/}
        <div
          onClick={() => navigation("/suport")}
          className={`${styleHelpers.getEPDivClass(location, "/suport")}`}
        >
          <p>Suport</p>
        </div>
        <div onClick={() => handleLogout()} className="header-edit-profile-div">
          <p>Log out</p>
        </div>
      </div>
    </div>
  );
}
